<template>
  <c-box
    title="Динамика посещаемости сайта"
    shadow
    header-divider
    :loading="loading"
  >
    <template v-slot:header-right>
      <form class="form-inline">
        <div class="form-group">
          Общая
          <label>
            <input
              v-model="source"
              type="radio"
              class="minimal"
              value="common"
            >
          </label>
          По устройствам
          <label>
            <input
              v-model="source"
              type="radio"
              class="minimal"
              value="devices"
            >
          </label>
        </div>
      </form>
    </template>

    <div id="tspm-g">
      <c-line-chart
        v-if="!loading && dataYandex.length"
        :chart-data="chartData"
        :options="chartOptions"
        :height="150"
      />
    </div>
    <no-data v-if="!loading && !dataYandex.length" />
  </c-box>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import moment from 'moment'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import CLineChart from '../../../../../../../resources/js/components/ui/CLineChart.vue'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'

export default {
  name: 'TrafficStructurePerMonth',
  components: { CLineChart, NoData, CBox },
  mixins: [sengine, diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    dataYandex: {
      type: Array,
      required: true
    },
    dataGoogle: {
      type: Array,
      required: true
    },
    dataDevices: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      source: 'common',
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 7,
            fontStyle: 'bold',
            fontColor: '#282828',
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            }
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.dataYandex.map(i => capitalizeFirstLetter(moment(i.ДатаОкончания).format('MMMM'))),
        datasets: this.source === 'common'
          ? [{
            label: this.getSengineName(this.$getConst('SENGINE_YANDEX')),
            data: this.dataYandex.map(i => i.КоличествоВизитов),
            fill: false,
            borderColor: '#ff0101',
            lineTension: 0
          },
          {
            label: this.getSengineName(this.$getConst('SENGINE_GOOGLE')),
            data: this.dataGoogle.map(i => i.КоличествоВизитов),
            fill: false,
            borderColor: '#4385f3',
            lineTension: 0
          }]
          : ['ВизитыЯндексПК', 'ВизитыЯндексМобильные', 'ВизитыГуглПК', 'ВизитыГуглМобильные', 'ВизитыОстальное'].map((key, index) => ({
            label: key.replace('Визиты', ''),
            data: this.dataDevices.map(i => i[key]),
            fill: false,
            borderColor: this.getNextDiagramColor(index),
            lineTension: 0
          }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #tspm-g {
    min-width: 890px;
  }
</style>
